"use strict";
import o from "./index.es99.js";
function e(r) {
  return o.isObject(r) && r.isAxiosError === !0;
}
export {
  e as default
};
//# sourceMappingURL=index.es112.js.map
